import { render } from "./CategoryTree.vue?vue&type=template&id=31084f78&scoped=true&ts=true"
import script from "./CategoryTree.vue?vue&type=script&lang=ts"
export * from "./CategoryTree.vue?vue&type=script&lang=ts"

import "./CategoryTree.vue?vue&type=style&index=0&id=31084f78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31084f78"],['__file',"src/components/product-category-selector/product-category-search-results/CategoryTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31084f78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31084f78', __exports__)) {
    api.reload('31084f78', __exports__)
  }
  
  module.hot.accept("./CategoryTree.vue?vue&type=template&id=31084f78&scoped=true&ts=true", () => {
    api.rerender('31084f78', render)
  })

}


export default __exports__